import { render } from "./Change_log.vue?vue&type=template&id=4832cc10&scoped=true"
import script from "./Change_log.vue?vue&type=script&lang=js"
export * from "./Change_log.vue?vue&type=script&lang=js"

import "./Change_log.vue?vue&type=style&index=0&id=4832cc10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4832cc10"]])

export default __exports__